import { takeEvery, put, call, select } from 'redux-saga/effects';
import { teams, toast, loading, modal, project } from '../types';
import scogo_apis from '../scogo_apis';
import { teamWork, chats as chatsPath } from '../router/roleWisePageRoute';
import { useSelector } from 'react-redux';
import { ScogoID } from '../utils/common';

export function* getTeamList(action) {
    const { dropdown, org, concat, page = 1, limit = 48, sort_by, query, members, select, give_actions } = action.payload;
    let queryParams = { limit, page };
    if (!['', undefined, null].includes(query)) queryParams.q = query;
    if (sort_by) queryParams.sortBy = sort_by;
    if (org) queryParams.org_id = org;
    if (members) queryParams.members = members;
    if (select) queryParams.select = select
    if (give_actions) queryParams.give_actions = give_actions;
    try {
        if (page > 1) {
            yield put({ type: loading.GET_NEXT_TEAMS_LIST_LOADING, payload: true });
        } else {
            yield put({ type: loading.GET_TEAMS_LIST_LOADING, payload: true });
        }
        const response = yield call(scogo_apis.teams.getTeams, {}, {}, queryParams);

        if (response.status === 200) {
            let data = response.data.data;
            if (dropdown) {
                data = [];
                response.data.data.forEach((item) => {
                    data.push({
                        key: `${item?.id}`,
                        value: item?.id,
                        label: `${item?.name}`,
                        default: item?.default,
                        type: item?.type,
                    });
                });
                yield put({ type: teams.GET_TEAMS_DROPDOWN_LIST_SUCCESS, payload: { data, page } });
            } else {
                yield put({ type: teams.GET_TEAMS_LIST_SUCCESS, payload: { data, concat } });

            }
        }
    } catch (error) {
        yield put({ type: teams.GET_TEAMS_LIST_SUCCESS, payload: { data: [], concat } });
    }
    if (page > 1) {
        yield put({ type: loading.GET_NEXT_TEAMS_LIST_LOADING, payload: false });
    } else {
        yield put({ type: loading.GET_TEAMS_LIST_LOADING, payload: false });
    }
}

export function* deleteTeam(action) {
    const { teamId, teamName, formName } = action.payload
    try {
        yield put({ type: loading.FORM_BUTTON_LOADING, payload: { formName, isLoading: true } })
        const response = yield call(scogo_apis.teams.deleteTeam, {}, { teamId }, {}, {})
        if (response.status === 200) {
            const message = `${teamName} Deleted Successfully`
            yield put({ type: modal.CLOSE_MODAL })
            yield put({ type: toast.SEND_TOAST, payload: { status: 'success', message } })
            yield put({ type: teams.DELETE_TEAM_SUCCESS, payload: { teamId } })
        } else {
            yield put({ type: modal.CLOSE_MODAL })
            yield put({ type: teams.DELETE_TEAM_FAILURE, payload: { message: 'Oops Something went wrong' } })
            yield put({ type: toast.SEND_TOAST, payload: { status: 'danger', message: 'Something went wrong' } })
        }
    } catch (error) {
        yield put({ type: teams.DELETE_TEAM_FAILURE, payload: { message: error } })
    }
    yield put({ type: loading.FORM_BUTTON_LOADING, payload: { formName, isLoading: false } })
}

export function* editTeam(action) {
    const { teamId, name, formName, description } = action.payload;
    try {
        yield put({ type: loading.FORM_BUTTON_LOADING, payload: { formName, isLoading: true } })
        const response = yield call(scogo_apis.teams.editTeam, {}, { teamId }, {}, { name, description })
        if (response.status === 200) {
            yield put({ type: modal.CLOSE_MODAL })
            yield put({ type: toast.SEND_TOAST, payload: { status: 'success', message: 'Team Details updated Successfully' } })
            yield put({ type: teams.EDIT_TEAM_SUCCESS, payload: { team: response.data } })

        } else {
            yield put({ type: modal.CLOSE_MODAL })
            yield put({ type: teams.EDIT_TEAM_FAILURE, payload: { message: 'Oops Something went wrong' } })
            yield put({ type: toast.SEND_TOAST, payload: { status: 'danger', message: 'Something went wrong' } })
        }
    } catch (error) {
        yield put({ type: teams.EDIT_TEAM_FAILURE, payload: { message: error } })
    }
    yield put({ type: loading.FORM_BUTTON_LOADING, payload: { formName, isLoading: false } })
}

export function* generateInviteLinkTeam(action) {
    const { teamId, invitationTo } = action.payload;
    try {
        const response = yield call(scogo_apis.user.generateInviteLink, {}, {}, {}, { id: teamId, invitationTo });
        if (response.status === 201) {
            yield put({ type: teams.GENERATE_INVITE_LINK_TEAM_SUCCESS, payload: { inviteLink: response.data.inviteLink, teamId } })
        } else {
            yield put({ type: teams.GENERATE_INVITE_LINK_TEAM_FAILURE, payload: { message: 'Oops Something went wrong' } })
        }

    } catch (error) {
        console.log('error:', error)
    }
    yield put({ type: loading.FORM_BUTTON_LOADING, payload: { isLoading: false } })
};


export function* addUsersInTeam(action) {
    const { users, teamId, teamName, formName, addedMembers, source, projectId } = action.payload
    try {
        yield put({ type: loading.FORM_BUTTON_LOADING, payload: { formName, isLoading: true } });
        const response = yield call(scogo_apis.user.addUsersInTeam, {}, { teamId }, {}, { users });
        if (response.status === 201) {
            yield put({ type: toast.SEND_TOAST, payload: { status: 'success', message: response.data.message || `Users Updated Successfully in ${teamName}` } });
            if (source === 'project') {
                yield put({ type: project.ADDED_PROJECT_TEAM_USERS_SUCCESS, payload: { addedMembers, teamId, projectId } });
            } else {
                yield put({ type: teams.ADD_USERS_TEAM_SUCCESS, payload: { users: addedMembers, teamId } });
            }
            yield put({ type: modal.CLOSE_MODAL })

        } else {
            yield put({ type: toast.SEND_TOAST, payload: { status: 'danger', message: 'Something went wrong' } })
        }
        yield put({ type: teams.ADD_USERS_TEAM_FAILURE, payload: { message: 'Something went wrong' } })
    } catch (error) {
        console.log('error:', error)
        yield put({ type: teams.ADD_USERS_TEAM_FAILURE, payload: { message: error } })
        yield put({ type: toast.SEND_TOAST, payload: { status: 'danger', message: error?.response?.data?.messages?.[0] || 'Something went wrong' } })
    }
    yield put({ type: loading.FORM_BUTTON_LOADING, payload: { formName, isLoading: false } })
}


export function* addUsersInTeamaByInvitation(action) {
    const { navigate, inviteId } = action.payload;

    try {
        const response = yield call(scogo_apis.user.addUsersInTeamsByInvitation, {}, { inviteId });
        if (response.status === 200) {
            if (navigate) {
                const { invitationTo } = response.data.data;
                if (invitationTo === 'TEAM') {
                    navigate(`${teamWork.path}?tab=teams`);
                } else if (invitationTo === 'CHAT') {
                    navigate(`${chatsPath.path}`);
                }
            }
        }
        if (response.status === 500) {
            navigate(`${teamWork.path}?tab=teams`)
        }
        else {
            yield put({ type: teams.ADD_USERS_IN_TEAMS_BY_INVITATION_FAILURE, payload: { message: 'Oops Something went wrong' } })
            yield put({ type: toast.SEND_TOAST, payload: { status: 'danger', message: 'Something went wrong' } })
        }

    } catch (error) {
        yield put({ type: toast.SEND_TOAST, payload: { status: 'danger', message: 'Something went wrong' } })
        yield put({ type: teams.ADD_USERS_IN_TEAMS_BY_INVITATION_FAILURE, payload: { message: error } })
    }
}

export function* removeUserFromTeam(action) {
    const { teamId, userName, teamName, members, formName, source, projectId } = action.payload;
    try {
        yield put({ type: loading.FORM_BUTTON_LOADING, payload: { formName, isLoading: true } })
        const response = yield call(scogo_apis.user.removeUsersFromTeam, {}, { teamId }, {}, { members })

        if (response.status === 201) {
            let message = `${userName} removed from ${teamName}`;
            yield put({ type: modal.CLOSE_MODAL })
            yield put({ type: toast.SEND_TOAST, payload: { status: 'success', message } })
            if (source === 'project') {
                yield put({ type: project.REMOVE_PROJECT_TEAM_USERS_SUCCESS, payload: { removedMembers: members, teamId, projectId } })
            } else {
                yield put({ type: teams.REMOVE_TEAM_AGENT_SUCCESS, payload: { removedMembers: members, teamId } })
            }
        } else {
            yield put({ type: teams.REMOVE_TEAM_AGENT_FAILURE, payload: { message: 'Oops Something went wrong' } });
        }
    } catch (error) {
        yield put({ type: toast.SEND_TOAST, payload: { status: 'danger', message: 'Something went wrong' } })
        yield put({ type: teams.REMOVE_TEAM_AGENT_FAILURE, payload: { message: error } })
    }
    yield put({ type: loading.FORM_BUTTON_LOADING, payload: { formName, isLoading: false } })
}


export function* getTeamUsersList(action) {
    const { org_id, query, limit, page, mobile, email, is_possible_remote_support } = action.payload;
    try {
        const queryParams = { org_id, limit, page, mobile, email, is_team_list: true };
        if (query) {
            queryParams.q = query;
        }
        if (is_possible_remote_support) {
            queryParams.is_possible_remote_support = is_possible_remote_support;
        }
        yield put({ type: loading.SET_TEAM_USERS_LIST_LOADING, payload: true });
        const response = yield call(scogo_apis.user.getUsersList, {}, {}, queryParams);
        if (response.status === 200) {
            const data = response.data.data.map((item) => ({
                key: item.id,
                value: item.id,
                label: `${item.full_name}`,
                user: item,
                id: item.id,
            }));
            yield put({ type: teams.GET_TEAM_USERS_LIST_SUCCESS, payload: { data, query } })
        } else {
            yield put({ type: teams.GET_TEAM_USERS_LIST_FAILURE, payload: { message: 'Oops Something went wrong' } })
        }
    } catch (error) {
        yield put({ type: teams.GET_TEAM_USERS_LIST_FAILURE, payload: { message: error } })
    }
    yield put({ type: loading.SET_TEAM_USERS_LIST_LOADING, payload: false });
}


export function* createNewTeam(action) {
    const { data, formName, callOnSuccess = () => { } } = action.payload;
    try {
        yield put({ type: loading.FORM_BUTTON_LOADING, payload: { formName, isLoading: true } })
        const response = yield call(scogo_apis.teams.addNewTeam, {}, {}, {}, data)
        if (response.status === 201) {
            yield put({ type: teams.GET_TEAMS_LIST_REQUEST, payload: {} })
            callOnSuccess();
            yield put({ type: teams.IS_SHOW_ADD_TEAM, payload: { isShowAddTeam: false } })
            yield put({ type: toast.SEND_TOAST, payload: { status: 'success', message: 'Team Added Successfully' } })
        } else {
            yield put({ type: toast.SEND_TOAST, payload: { status: 'danger', message: 'Something went wrong' } })
        }
    } catch (error) {
        yield put({ type: toast.SEND_TOAST, payload: { status: 'danger', message: error?.messages?.[0] || 'Something went wrong' } })
    }
    yield put({ type: loading.FORM_BUTTON_LOADING, payload: { formName, isLoading: false } })
}

export function* linkProject(action) {
    const { teamId, project_ids, formName } = action.payload;
    try {
        yield put({ type: loading.FORM_BUTTON_LOADING, payload: { formName, isLoading: true } })
        const response = yield call(scogo_apis.teams.linkProject, {}, { teamId }, {}, { project_ids });
        if (response.status === 201) {
            yield put({ type: teams.LINK_PROJECT_SUCCESS, payload: { teamId, project_ids } })
            yield put({ type: modal.CLOSE_MODAL })
            yield put({ type: toast.SEND_TOAST, payload: { status: 'success', message: response.data.message || 'Project Linked Successfully' } })
        }
    } catch (error) {
        yield put({ type: toast.SEND_TOAST, payload: { status: 'danger', message: error?.response?.data?.messages?.[0] || 'Something went wrong' } })
    }
    yield put({ type: loading.FORM_BUTTON_LOADING, payload: { formName, isLoading: false } })
}

export function* unlinkProject(action) {
    const { teamId, project_ids, formName } = action.payload;
    try {
        yield put({ type: loading.FORM_BUTTON_LOADING, payload: { formName, isLoading: true } })
        const response = yield call(scogo_apis.teams.unlinkProject, {}, { teamId }, {}, { project_ids });
        if (response.status === 201) {
            yield put({ type: teams.UNLINK_PROJECT_SUCCESS, payload: { teamId, project_ids } });
            yield put({ type: modal.CLOSE_MODAL })
        } else {
            yield put({ type: teams.UNLINK_PROJECT_FAILURE, payload: { message: 'Oops Something went wrong' } })
        }
    } catch (error) {
        yield put({ type: teams.UNLINK_PROJECT_FAILURE, payload: { message: error } })
    }
    yield put({ type: loading.FORM_BUTTON_LOADING, payload: { formName, isLoading: false } })
}

export function* getLinkedProjects(action) {
    const { teamId } = action.payload;
    try {
        yield put({ type: loading.SET_TEAMS_LINKED_PROJECTS_LOADING, payload: true });
        const response = yield call(scogo_apis.teams.getLinkedProjects, {}, { teamId });
        if (response.status === 200) {
            yield put({ type: teams.GET_LINKED_PROJECTS_SUCCESS, payload: response.data.data })
        } else {
            yield put({ type: teams.GET_LINKED_PROJECTS_SUCCESS, payload: [] })
            yield put({ type: teams.GET_LINKED_PROJECTS_FAILURE, payload: { message: 'Oops Something went wrong' } })
        }
    } catch (error) {
        yield put({ type: teams.GET_LINKED_PROJECTS_FAILURE, payload: { message: error } })
        yield put({ type: teams.GET_LINKED_PROJECTS_SUCCESS, payload: [] })
    }
    yield put({ type: loading.SET_TEAMS_LINKED_PROJECTS_LOADING, payload: false });
}


export function* getTeamsDropDownList(action) {
    let { org_id, query, page, limit } = action.payload;
    try {
        const newLoggedUserData = yield select((state) => state.auth.newLoggedUserData);
        const isScogoMember = newLoggedUserData.orgMemberships.find(({ id }) => id === ScogoID);
        let queryParams = { page, limit };
        if (query) queryParams.q = query;
        if (isScogoMember && org_id) {
            queryParams.org_id = `${org_id},${ScogoID}`
        }
        yield put({ type: loading.SET_TEAMS_DROPDOWN_LIST_LOADING, payload: true });
        const response = yield call(scogo_apis.teams.getTeamsDropDownList, {}, {}, queryParams);
        if (response.status === 200) {
            let t = response.data.data.map((item) => ({
                key: item.id,
                value: item.id,
                label: `${item.name}`,
            }));
            yield put({ type: teams.GET_TEAMS_DROPDOWN_LIST_SUCCESS, payload: { teams: t, page } })
        } else {
            yield put({ type: teams.GET_TEAMS_DROPDOWN_LIST_FAILURE, payload: { message: 'Oops Something went wrong' } })
        }
    } catch (error) {
        yield put({ type: teams.GET_TEAMS_DROPDOWN_LIST_FAILURE, payload: { message: error } })
    }
    yield put({ type: loading.SET_TEAMS_DROPDOWN_LIST_LOADING, payload: false });
}
export function* getTeamsUsersList(action) {
    const { teamId, page = 1, limit = 10 } = action.payload

    try {
        yield put({ type: loading.TEAM_MEAMBER_LOADING, payload: true })
        const response = yield call(scogo_apis.user.getTeamUserList, {}, { teamId }, { page, limit })
        if (response.status === 200) {
            yield put({ type: teams.GET_TEAMS_USERS_LIST_SUCCESS, payload: { teamId, data: response.data.data } })
        }
    } catch (error) {

    }
    yield put({ type: loading.TEAM_MEAMBER_LOADING, payload: false })
}
export default function* spSaga() {
    yield takeEvery(teams.GET_TEAMS_LIST_REQUEST, getTeamList);
    yield takeEvery(teams.DELETE_TEAM_REQUEST, deleteTeam);
    yield takeEvery(teams.EDIT_TEAM_REQUEST, editTeam);
    yield takeEvery(teams.GENERATE_INVITE_LINK_TEAM_REQUEST, generateInviteLinkTeam);
    yield takeEvery(teams.ADD_USERS_TEAM_REQUEST, addUsersInTeam);
    yield takeEvery(teams.ADD_USERS_IN_TEAMS_BY_INVITATION_REQUEST, addUsersInTeamaByInvitation)
    yield takeEvery(teams.REMOVE_TEAM_AGENT_REQUEST, removeUserFromTeam)
    yield takeEvery(teams.GET_TEAM_USERS_LIST_REQUEST, getTeamUsersList)
    yield takeEvery(teams.CREATE_NEW_TEAM_REQUEST, createNewTeam)
    yield takeEvery(teams.LINK_PROJECT_REQUEST, linkProject)
    yield takeEvery(teams.UNLINK_PROJECT_REQUEST, unlinkProject)
    yield takeEvery(teams.GET_LINKED_PROJECTS_REQUEST, getLinkedProjects)
    yield takeEvery(teams.GET_TEAMS_DROPDOWN_LIST_REQUEST, getTeamsDropDownList)
    yield takeEvery(teams.GET_TEAMS_USERS_LIST_REQUEST, getTeamsUsersList)


}
